// Minicart
/*
document.addEventListener('DOMContentLoaded', function() {
  const cartIcon = document.getElementById('open-mini-cart');
  const miniCart = document.getElementById('mini-cart');
  const closeBtn = document.querySelector('.close-mini-cart');
  const overlay = document.querySelector('.mini-cart-overlay');
  const itemsContainer = document.getElementById('mini-cart-items');
  const totalContainer = document.getElementById('mini-cart-total');
  const successMessageContainer = document.getElementById('mini-cart-success-message');

  function formatMoney(cents, format = "${{amount}}") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    let amount = "";
    switch (format) {
      case "${{amount}}":
        amount = (cents / 100).toFixed(2);
        value = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        break;
      default:
        amount = (cents / 100).toFixed(2);
        value = amount;
        break;
    }
    return format.replace("${{amount}}", value);
  }

  window.Shopify = window.Shopify || {};
  Shopify.moneyFormat = Shopify.moneyFormat || "${{amount}}";

  function openMiniCart() {
    miniCart.classList.add('show');
  }

  function closeMiniCart() {
    miniCart.classList.remove('show');
    successMessageContainer.textContent = ''; // Reset messaggio quando chiudi
  }

  function loadMiniCart(showSuccess = false) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length === 0) {
          itemsContainer.innerHTML = '<p>Il carrello è vuoto.</p>';
          totalContainer.textContent = '';
          updateCartCount();
          return;
        }

        let itemsHtml = '';
        cart.items.forEach(item => {
          let optionsHtml = '';
          if (item.options_with_values && item.options_with_values.length > 0) {
            optionsHtml = item.options_with_values
              .map(opt => `<p class="cart-option">${opt.name}: <strong>${opt.value}</strong></p>`)
              .join('');
          }

          itemsHtml += `
            <div class="mini-cart-item">
              <img src="${item.image}" alt="${item.title}" style="width: 60px;">
              <div>
                <h5 class="cart-title-product">${item.product_title}</h5>
                ${optionsHtml}
                <p>Quantità: ${item.quantity}</p>
                <p class="price">${formatMoney(item.final_line_price, Shopify.moneyFormat)} &euro;</p>
              </div>
            </div>
          `;
        });

        itemsContainer.innerHTML = itemsHtml;
        totalContainer.textContent = `${formatMoney(cart.total_price, Shopify.moneyFormat)}`;
        updateCartCount();

        if (showSuccess) {
          successMessageContainer.textContent = "Prodotto aggiunto con successo!";
          setTimeout(() => {
            successMessageContainer.textContent = "";
          }, 3000);
        }
      })
      .catch(error => {
        console.error('Errore caricamento carrello:', error);
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const badge = document.getElementById('cart-count-badge');
        const count = cart.item_count;
        if (count > 0) {
          badge.textContent = count;
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Errore aggiornamento badge:', error);
      });
  }

  cartIcon.addEventListener('click', function(e) {
    e.preventDefault();
    openMiniCart();
    loadMiniCart();
  });

  closeBtn.addEventListener('click', closeMiniCart);
  overlay.addEventListener('click', closeMiniCart);

  // Quando viene aggiunto al carrello (hook evento custom)
  document.body.addEventListener('ajaxCart:afterAdd', () => {
    loadMiniCart(true);
    openMiniCart();
  });

  // Badge iniziale
  updateCartCount();
});

*/



document.addEventListener("DOMContentLoaded", function () {

// header scroll
const header = document.querySelector(".header-wrapper");
const scrollThreshold = 30;
const isHomepage = document.body.classList.contains('template-index');

function checkScroll() {
  header.classList.add("scrolled");
}

// Avvio iniziale e al scroll
checkScroll();
window.addEventListener("scroll", checkScroll);




  //fixed header-wrapperconst header = document.querySelector('.header-wrapper');
  const announcement = document.querySelector('.announcement-bar-section');

  let lastScrollTop = 0;

  const updateHeaderPosition = () => {
    const scrollY = window.scrollY;

    const announcementHeight = announcement ? announcement.offsetHeight : 0;

    if (scrollY >= announcementHeight) {
      header.classList.add('fixed');
      header.classList.add('scrolled'); // se hai già uno stile scrolled per background
    } else {
      header.classList.remove('fixed');
    }
  };

  window.addEventListener('scroll', updateHeaderPosition);



  
  // carousel

  if ( $('.owl-carousel.product-carousel__list').length >= 1 ){
    
    $('.owl-carousel.product-carousel__list').owlCarousel({
      loop: false,
      margin: 6,
      nav: true,
      dots: true,
      responsive: {
        0: {
          items: 1,
          slideBy: 1
        },
        768: {
          items: 2,
          slideBy: 2
        },
        1024: {
          items: 4,
          slideBy: 4
        }
      }
    });  
  }


  if ( $('.owl-carousel.days-carousel__list').length >= 1 ){
    $('.owl-carousel.days-carousel__list').owlCarousel({
      loop: true,
      margin: 3,
      nav: true,
      dots: true,
      responsive: {
        0: {
          items: 1,
          slideBy: 1
        },
        768: {
          items: 2,
          slideBy: 2
        }
      }
    });  
  }

  if ( $('.carousel-media-wrapper__container').length >= 1 ){
    $('.carousel-media-wrapper__container').owlCarousel({
      items: 1,
      loop: true,
      margin: 3,
      nav: true,
      dots: true,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true
    });  
  }

  if ( $('.splash-carousel').length >= 1 ){
    $('.splash-carousel').owlCarousel({
      items: 1,
      loop: true,
      margin: 0,
      nav: true,
      dots: true
    });  
  }

  if (window.innerWidth <= 768) {
    if ( $('.product-media-gallery').length >= 1 ){
      $('.product-media-gallery').owlCarousel({
        items: 1,
        loop: true,
        margin: 6,
        nav: true,
        dots: true,
        responsive: {
          0: { items: 1 }
        }
      });
    }
    if ( $('.three-banner__wrapper.owl-carousel').length >= 1 ){
      $('.three-banner__wrapper.owl-carousel')
      .on('initialized.owl.carousel', function(event) {
        $(this).addClass('active-overflow');
      })
      .owlCarousel({
        items: 1,
        loop: false,
        margin: 6,
        nav: false,
        dots: true,
        responsive: {
          0: { items: 1 }
        }
      });
    }

    if ( $('.divine-style-wrapper__container.owl-carousel').length >= 1 ){
      $('.divine-style-wrapper__container.owl-carousel')
      .on('initialized.owl.carousel', function(event) {
        $(this).addClass('active-overflow');
      })
      .owlCarousel({
        items: 1,
        loop: false,
        margin: 6,
        nav: false,
        dots: true,
        responsive: {
          0: { items: 1 }
        }
      });
    }
    
  }


  // tabs desc product
  const tabs = document.querySelectorAll("#product-tabs .tabs-nav li");
  const contents = document.querySelectorAll("#product-tabs .tab-content");

  // Rimuovi active iniziali
  tabs.forEach(t => t.classList.remove("active"));
  contents.forEach(c => c.classList.remove("active"));

  // Attiva primo tab disponibile
  if (tabs.length > 0) {
    tabs[0].classList.add("active");
    const firstTarget = tabs[0].getAttribute("data-tab");
    const firstContent = document.querySelector(`#product-tabs .tab-content[data-content="${firstTarget}"]`);
    if (firstContent) {
      firstContent.classList.add("active");
    }
  }


  // tabs size table
  document.querySelectorAll('#product-tabs-size .tabs-nav li').forEach(tab => {
    tab.addEventListener('click', function() {
      document.querySelectorAll('#product-tabs-size .tabs-nav li').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
  
      let tabContent = this.getAttribute('data-tab');
      document.querySelectorAll('.tab-content').forEach(content => {
        if(content.getAttribute('data-content') === tabContent){
          content.classList.add('active');
        } else {
          content.classList.remove('active');
        }
      });
    });
  });

  
  // Gestione click Tabs content
  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");
      const target = this.getAttribute("data-tab");
      const content = document.querySelector(`#product-tabs .tab-content[data-content="${target}"]`);
      if (content) {
        content.classList.add("active");
      }
    });
  });


  

  // questo serve per generare il carosello dopo che shopify ha caricato i correlati in asincrono
  var recommendations = document.querySelector("product-recommendations");
  if (!recommendations) return;

  // Observer per intercettare quando vengono aggiunti figli (cioè i prodotti)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (
        mutation.addedNodes.length > 0 &&
        mutation.target.querySelector('.owl-carousel.product-carousel__list') &&
        !mutation.target.querySelector('.owl-loaded') // eviti di inizializzare due volte
      ) {
        $('.owl-carousel.product-carousel__list').owlCarousel({
          loop: false,
          margin: 6,
          nav: true,
          dots: true,
          responsive: {
            0: {
              items: 1,
              slideBy: 1
            },
            768: {
              items: 2,
              slideBy: 2
            },
            1024: {
              items: 4,
              slideBy: 4
            }
          }
        });
      }
    });
  });

  observer.observe(recommendations, { childList: true, subtree: true });

  

});


// menu mobile
document.addEventListener('click', function (event) {
  // CLICK SU LINK DI LIVELLO 0 CON SOTTOMENU
  const link = event.target.closest('.gm-item.gm-level-0.gm-has-submenu > .gm-target');
  if (link) {
    const parent = link.closest('.gm-item');
    const submenu = parent.querySelector('.gm-submenu.gm-mega');
    const background = submenu.querySelector('.submenu-background');

    if (!background.querySelector('.submenu-header')) {
      const title = link.querySelector('.gm-text')?.textContent.trim() || 'Indietro';

      background.innerHTML = `
        <div class="submenu-header">
          <span class="submenu-back"></span>
          <span class="submenu-title">${title}</span>
        </div>
      `;
    }

    return; // Evita doppio trigger su click successivo
  }

  // CLICK SU FRECCIA BACK
  const backBtn = event.target.closest('.submenu-back');
  if (backBtn) {
    const parent = backBtn.closest('.gm-item.gm-active');
    if (parent) parent.classList.remove('gm-active');
  }
});





// navigazione pagine servizio clienti
document.addEventListener("DOMContentLoaded", function () {
  const currentPath = window.location.pathname;
  const links = document.querySelectorAll('.menu-laterale-link');

  links.forEach(function (link) {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });
});


// Attiva overlay guida taglie al click
document.addEventListener('click', function (e) {
  const target = e.target;
  // Click su size-guide-link
  if (target.closest('.size-guide-link')) {
    e.preventDefault();
    document.body.classList.add('active-overlay-size-guide');
  }

  // Click su close-overlay
  if (target.closest('.close-overlay')) {
    document.body.classList.remove('active-overlay-size-guide');
  }

});



// mega menu background
document.addEventListener('mouseover', function (event) {
  const target = event.target.closest('li.gm-item');

  if (target) {
    document.body.classList.add('mega-menu-active');
  }
});

document.addEventListener('mouseout', function (event) {
  const target = event.target.closest('li.gm-item');

  if (target) {
    document.body.classList.remove('mega-menu-active');
  }
});


// leggi tutto description 
document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.querySelector('.toggle-description');
  const shortDesc = document.querySelector('.description-short');
  const fullDesc = document.querySelector('.description-full');

  if (!toggleBtn || !shortDesc || !fullDesc) return;

  toggleBtn.addEventListener('click', () => {
    const isExpanded = fullDesc.style.display === 'block';

    if (isExpanded) {
      fullDesc.style.display = 'none';
      shortDesc.style.display = 'block';
      toggleBtn.textContent = 'Leggi tutto';
    } else {
      fullDesc.style.display = 'block';
      shortDesc.style.display = 'none';
      toggleBtn.textContent = 'Riduci';
    }
  });
});





// click grid cataglogo
document.addEventListener("DOMContentLoaded", function () {
  const grid = document.getElementById('product-grid');
  const buttons = document.querySelectorAll('.grid-toggle__btn');

  // 1. Applica preferenza salvata
  const savedCols = localStorage.getItem('gridCols');
  if (savedCols && grid) {
    grid.classList.remove('grid--3-col-desktop', 'grid--4-col-desktop');
    grid.classList.remove('grid-cols-3', 'grid-cols-4');
    grid.classList.add(`grid--${savedCols}-col-desktop`);
    grid.classList.add(`grid-cols-${savedCols}`);
    buttons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.cols === savedCols);
    });
  }

  // 2. Salva nuova preferenza
  buttons.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const cols = this.dataset.cols;
      localStorage.setItem('gridCols', cols);

      grid.classList.remove('grid--3-col-desktop', 'grid--4-col-desktop');
      grid.classList.remove('grid-cols-3', 'grid-cols-4');
      grid.classList.add(`grid--${cols}-col-desktop`);
      grid.classList.add(`grid-cols-${cols}`);

      buttons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const grid = document.getElementById('product-grid');
  const buttons = document.querySelectorAll('.grid-toggle__btn_mobile');

  // 1. Applica preferenza salvata
  const savedCols = localStorage.getItem('gridCols');
  if (savedCols && grid) {
    grid.classList.remove('grid--1-col-desktop', 'grid--2-col-desktop');
    grid.classList.remove('grid-cols-1', 'grid-cols-2');
    grid.classList.add(`grid--${savedCols}-col-desktop`);
    grid.classList.add(`grid-cols-${savedCols}`);
    buttons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.cols === savedCols);
    });
  }

  // 2. Salva nuova preferenza
  buttons.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const cols = this.dataset.cols;
      localStorage.setItem('gridCols', cols);

      grid.classList.remove('grid--1-col-desktop', 'grid--2-col-desktop');
      grid.classList.remove('grid-cols-1', 'grid-cols-2');
      grid.classList.add(`grid--${cols}-col-desktop`);
      grid.classList.add(`grid-cols-${cols}`);

      buttons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
});



// cambio lingua
document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.querySelector('.lang-switcher__toggle');
  const wrapper = document.querySelector('.lang-switcher');

  if (toggle && wrapper) {
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      wrapper.classList.toggle('active');
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        wrapper.classList.remove('active');
      }
    });
  }
});




//popup aggiunta prodotto al carrello
document.addEventListener('DOMContentLoaded', function () {
  // Mostra popup
  function showAddToCartPopup() {
    const popup = document.querySelector('.popup-add-product');
    if (!popup) return;

    popup.style.display = 'block';
    popup.style.opacity = '1';

    setTimeout(() => {
      popup.style.transition = 'opacity 0.5s ease';
      popup.style.opacity = '0';
    }, 2500);

    setTimeout(() => {
      popup.style.display = 'none';
      popup.style.transition = '';
    }, 3000);
  }

  // Aggiorna il conteggio del carrello nella .cart-count-bubble
  function ensureCartBubble() {
    const container = document.querySelector('#cart-icon-bubble');
    if (!container) return null;

    let bubble = container.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble'; // Dawn usa questa classe
      bubble.innerHTML = `
        <span aria-hidden="true">0</span>
        <span class="visually-hidden">items in cart</span>
      `;
      container.appendChild(bubble);
    }
    return bubble;
  }

  function updateCartCountBubble() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const bubble = ensureCartBubble();
        if (!bubble) return;

        const numSpan = bubble.querySelector('span[aria-hidden="true"]');
        const count = cart.item_count || 0;

        if (count > 0) {
          if (numSpan) numSpan.textContent = count;
          bubble.style.display = 'flex';       // visibile
          bubble.classList.remove('hidden');   // alcuni temi usano questa classe
          // opzionale: aria-live
          bubble.setAttribute('aria-live', 'polite');
        } else {
          bubble.style.display = 'none';
          bubble.classList.add('hidden');
        }
      })
      .catch(console.error);
  }

  // Ascolta evento custom Shopify (già presente in molti temi moderni)
  document.body.addEventListener('ajaxCart:afterAdd', function () {
    showAddToCartPopup();
    updateCartCountBubble();
  });

  // In fallback, puoi intercettare anche i form classici
  const forms = document.querySelectorAll('form[action^="/cart/add"]');
  forms.forEach(form => {
    form.addEventListener('submit', function (e) {
      setTimeout(() => {
        showAddToCartPopup();
        updateCartCountBubble();
      }, 800); // ritardo per aspettare risposta AJAX
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  try {
    // serve il product.handle nel DOM; la maggior parte dei temi lo rende disponibile
    const productHandle =
      (window.meta && window.meta.product && window.meta.product.handle) ||
      (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.handle) ||
      (document.querySelector('link[rel="canonical"]')?.href.match(/\/products\/([^/?#]+)/)?.[1]) ||
      null;

    // variante corrente dal form o dall’URL
    const currentVariantId =
      document.querySelector('input[name="id"], select[name="id"]')?.value ||
      new URLSearchParams(location.search).get('variant') ||
      null;

    if (productHandle && currentVariantId) {
      const wl = getRawWishlist();
      let changed = false;
      for (let i = 0; i < wl.length; i++) {
        const e = wl[i];
        if (e && typeof e === 'object' && String(e.variantId) === String(currentVariantId) && (!e.handle || e.handle === null)) {
          wl[i] = { variantId: String(currentVariantId), handle: productHandle };
          changed = true;
        }
      }
      if (changed) {
        setRawWishlist(wl);
        // opzionale: aggiorna UI subito
        if (window.WishlistAPI) { WishlistAPI.updateIcons(); WishlistAPI.updateCount(); }
      }
    }
  } catch(e){}
});


// Recupera wishlist da localStorage
// WISHLIST SYSTEM
// per eliminare i prodotti in wishlist da fare in console del browser
// localStorage.removeItem('wishlist')
/*
(function () {
  function getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist') || '[]');
  }

  function saveWishlist(wishlist) {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

  function updateWishlistCount() {
    const count = getWishlist().length;
    const badge = document.querySelector('.wishlist-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function updateWishlistIcons() {
    const wishlist = getWishlist();
    document.querySelectorAll('.add-to-wishlist').forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (!handle) return;
      btn.classList.toggle('active', wishlist.includes(handle));
    });
  }

  function toggleWishlist(productHandle) {
    let wishlist = getWishlist();
    const index = wishlist.indexOf(productHandle);

    if (index > -1) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push(productHandle);
    }

    saveWishlist(wishlist);
    updateWishlistCount();
    updateWishlistIcons();
  }

  document.addEventListener('DOMContentLoaded', function () {
    // click cuore
    document.body.addEventListener('click', function (e) {
      const btn = e.target.closest('.add-to-wishlist');
      if (!btn) return;

      e.preventDefault();
      const handle = btn.dataset.productHandle;
      if (handle) toggleWishlist(handle);
    });

    // inizializza
    updateWishlistCount();
    updateWishlistIcons();

    // opzionale: aggiorna anche dopo caricamenti ajax (Shopify lazy)
    const observer = new MutationObserver(updateWishlistIcons);
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();

*/






/**
 * WISHLIST per VARIANTE con retro-compatibilità
 * - LocalStorage key: 'wishlist'
 * - Formati accettati:
 *    - Nuovo: { variantId: "1234567890", handle: "product-handle" }
 *    - Legacy: "product-handle" (stringa)
 *
 * Include uno shim compatibile `window.wlm` per eliminare l'errore "wlm is not defined".
 * Metodi shim:
 *   wlm.init()
 *   wlm.add(variantId, handle?)
 *   wlm.remove(variantId)
 *   wlm.contains(variantId) -> boolean
 */

(function () {
  const STORAGE_KEY = 'wishlist';

  // ===== Storage helpers =====
  function getRawWishlist() {
    try {
      const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(raw) ? raw : [];
    } catch { return []; }
  }
  function setRawWishlist(arr) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr || []));
  }

  // ===== API variante =====
  function addToWishlistByVariant(variantId, handle) {
  if (!variantId) return;
  const id = String(variantId);
  const wl = getRawWishlist(); // tua funzione già esistente

  let changed = false;
  // cerca una voce esistente per la stessa variante
  for (let i = 0; i < wl.length; i++) {
    const e = wl[i];
    if (e && typeof e === 'object' && String(e.variantId) === id) {
      // arricchisci handle se manca
      if ((!e.handle || e.handle === null) && handle) {
        wl[i] = { variantId: id, handle: handle };
        changed = true;
      }
      // già presente: niente push
      if (changed) setRawWishlist(wl);
      updateWishlistCount();
      updateWishlistIcons();
      return;
    }
  }

  // non esiste: inserisci nuovo
  wl.push({ variantId: id, handle: handle || null });
  setRawWishlist(wl);
  updateWishlistCount();
  updateWishlistIcons();
}

  function removeFromWishlistByVariant(variantId) {
    const id = String(variantId);
    const wl = getRawWishlist().filter(e => !(e && typeof e === 'object' && String(e.variantId) === id));
    setRawWishlist(wl);
    updateWishlistCount();
    updateWishlistIcons();
  }

  function isInWishlistByVariant(variantId) {
    const id = String(variantId);
    const wl = getRawWishlist();
    return wl.some(e => e && typeof e === 'object' && String(e.variantId) === id);
  }

  // Legacy (per rimozione da lista vecchia per handle)
  function removeLegacyByHandle(handle) {
    const wl = getRawWishlist().filter(e => !(typeof e === 'string' && e === handle) && !(e && typeof e === 'object' && e.handle === handle));
    setRawWishlist(wl);
    updateWishlistCount();
    updateWishlistIcons();
  }

  // ===== UI helpers =====
  function updateWishlistCount() {
    const count = getRawWishlist().length;
    const badge = document.querySelector('.wishlist-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function getVariantIdForButton(btn) {
    if (!btn) return null;
    // 1) data-variant-id
    if (btn.dataset.variantId) return btn.dataset.variantId;
    // 2) form input/select name="id"
    const form = btn.closest('form');
    const idInput = form?.querySelector('input[name="id"], select[name="id"]');
    if (idInput?.value) return idInput.value;
    // 3) URL ?variant=
    const urlId = new URLSearchParams(location.search).get('variant');
    if (urlId) return urlId;
    // 4) eventuale data-product-variant-id
    if (btn.dataset.productVariantId) return btn.dataset.productVariantId;
    return null;
  }

  function getHandleForButton(btn) {
    if (!btn) return null;
    if (btn.dataset.productHandle) return btn.dataset.productHandle;
    // tenta di ricavare dal link prodotto vicino
    const link = btn.closest('.product-card')?.querySelector('a.product-card-link[href*="/products/"]');
    if (link) {
      const m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m && m[1]) return m[1];
    }
    return null;
  }

  function updateWishlistIcons() {
    const entries = getRawWishlist();
    document.querySelectorAll('.add-to-wishlist').forEach(btn => {
      const variantId = getVariantIdForButton(btn);
      const on = variantId ? isInWishlistByVariant(variantId) : false;
      btn.classList.toggle('active', on);

      // Mostra/Nasconde le due icone se presenti
      const vuoto = btn.querySelector('.vuoto');
      const pieno = btn.querySelector('.pieno');
      if (vuoto && pieno) {
        vuoto.style.display = on ? 'none' : '';
        pieno.style.display = on ? '' : 'none';
      }
    });
  }

  // function toggleWishlistForButton(btn) {
  //   const variantId = getVariantIdForButton(btn);
  //   const handle = getHandleForButton(btn);
  //   if (!variantId) return;
  //   if (isInWishlistByVariant(variantId)) {
  //     removeFromWishlistByVariant(variantId);
  //   } else {
  //     addToWishlistByVariant(variantId, handle);
  //   }
  // }
  function toggleWishlistForButton(btn) {
    const variantId = getVariantIdForButton(btn);
    const handle = btn.dataset.productHandle || getHandleForButton(btn) || null;
    if (!variantId) return;
    if (isInWishlistByVariant(variantId)) {
      removeFromWishlistByVariant(variantId);
    } else {
      addToWishlistByVariant(variantId, handle); // qui ora fa enrichment
    }
  }

  // ===== Event binding =====
  document.addEventListener('DOMContentLoaded', function () {
    // Click sul cuore
    document.body.addEventListener('click', function (e) {
      const btn = e.target.closest('.add-to-wishlist');
      if (!btn) return;
      e.preventDefault();
      toggleWishlistForButton(btn);
    });

    // Quando cambia variante nel form
    document.body.addEventListener('change', function (e) {
      const t = e.target;
      if (t.matches('select[name="id"], input[name="id"]')) {
        updateWishlistIcons();
      }
    });

    // Osserva cambi DOM
    const observer = new MutationObserver(updateWishlistIcons);
    observer.observe(document.body, { childList: true, subtree: true });

    updateWishlistCount();
    updateWishlistIcons();
  });

  // ===== Espone API globali utili ed il compat shim `wlm` =====
  window.WishlistAPI = {
    getRaw: getRawWishlist,
    setRaw: setRawWishlist,
    addVariant: addToWishlistByVariant,
    removeVariant: removeFromWishlistByVariant,
    hasVariant: isInWishlistByVariant,
    removeLegacyByHandle,
    updateIcons: updateWishlistIcons,
    updateCount: updateWishlistCount
  };

  

  // Shim compat per vecchi riferimenti `wlm.*`
window.wlm = window.wlm || {};

(function (w) {
  function safe(fn){ try{ return fn(); }catch(e){} }

  // onReady helper
  function onReady(fn){
    if (typeof fn !== 'function') return;
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  // jQuery wrapper: usa jQuery/$ se presente, altrimenti micro-shim
  var jq = (function(){
    if (typeof window.jQuery === 'function') return window.jQuery;
    if (typeof window.$ === 'function') return window.$;

    function miniJQ(arg){
      if (typeof arg === 'function'){
        onReady(arg);
        return { ready: onReady };
      }
      var nodes = [];
      if (typeof arg === 'string') nodes = Array.from(document.querySelectorAll(arg));
      else if (arg && arg.length != null) nodes = Array.from(arg);
      else if (arg) nodes = [arg];

      return {
        length: nodes.length,
        0: nodes[0],
        on: function(){ return this; },
        off: function(){ return this; },
        find: function(sel){ return miniJQ(nodes[0] ? nodes[0].querySelectorAll(sel) : []); },
        addClass: function(){ return this; },
        removeClass: function(){ return this; },
        toggleClass: function(){ return this; },
        show: function(){ return this; },
        hide: function(){ return this; },
        ready: onReady
      };
    }
    miniJQ.ready = onReady;
    return miniJQ;
  })();

  // Metodi principali
  w.init = w.init || function () {
    safe(() => window.WishlistAPI.updateIcons());
    safe(() => window.WishlistAPI.updateCount());
  };
  w.add = w.add || function (variantId, handle) {
    safe(() => window.WishlistAPI.addVariant(variantId, handle));
  };
  w.remove = w.remove || function (variantId) {
    safe(() => window.WishlistAPI.removeVariant(variantId));
  };
  w.contains = w.contains || function (variantId) {
    return safe(() => window.WishlistAPI.hasVariant(variantId)) || false;
  };

  // Metodi legacy frequenti
  w.jq = w.jq || jq;
  w.toggleContent = w.toggleContent || function () {
    safe(() => window.WishlistAPI.updateIcons());
    safe(() => window.WishlistAPI.updateCount());
  };
  w.navigateByLocation = w.navigateByLocation || function(){
    safe(() => window.WishlistAPI.updateIcons());
    safe(() => window.WishlistAPI.updateCount());
  };
  w.refresh = w.refresh || function () {
    safe(() => window.WishlistAPI.updateIcons());
    safe(() => window.WishlistAPI.updateCount());
  };
  w.ready = w.ready || function(fn){ jq.ready(fn); };
  w.open = w.open || function(){};
  w.close = w.close || function(){};
  w.on = w.on || function(){};
  w.emit = w.emit || function(){};

  // NUOVO: rimuove/neutralizza link dentro un container -> qui basta un no-op
  // Alcuni temi lo chiamano così: wlm.removeLinks($(container)) o wlm.removeLinks(container)
  w.removeLinks = w.removeLinks || function(_container){ /* no-op */ };

  // Proxy: se uno script chiama un metodo inesistente (es. wlm.fooBar()),
  // creiamo al volo uno stub funzione per evitare TypeError.
  try {
    window.wlm = new Proxy(window.wlm, {
      get(target, prop, receiver) {
        if (prop in target) return Reflect.get(target, prop, receiver);
        if (typeof prop === 'string') {
          const fn = function(){ /* legacy no-op */ };
          target[prop] = fn; // cache
          // console.warn('[wlm shim] creato stub per metodo mancante:', prop);
          return fn;
        }
        return Reflect.get(target, prop, receiver);
      }
    });
  } catch(e) {
    // Se Proxy non disponibile, ignoriamo: restano i metodi definiti sopra
  }

})(window.wlm);

})();

/* ===== Sézane-style product gallery ===== */
(function(){
  function initSezaneGallery(){
    var gallery = document.querySelector('.sezane-gallery');
    if(!gallery) return;

    var mainContainer = gallery.querySelector('.sezane-gallery__main');
    var thumbsContainer = gallery.querySelector('.sezane-gallery__thumbs');
    var arrowUp = gallery.querySelector('.sezane-gallery__arrow--up');
    var arrowDown = gallery.querySelector('.sezane-gallery__arrow--down');

    if(!mainContainer) return;

    /* --- Read variant→media map --- */
    var mapEl = document.querySelector('[id^="SezaneVariantMediaMap-"]');
    var variantMediaMap = {};
    if(mapEl){
      try { variantMediaMap = JSON.parse(mapEl.textContent); } catch(e){}
    }

    /* --- Show one main image, hide the rest --- */
    function showSingleImage(mediaId){
      var mainImages = mainContainer.querySelectorAll('.sezane-gallery__main-image');
      mainImages.forEach(function(img){
        if(img.getAttribute('data-media-id') === String(mediaId)){
          img.style.display = '';
          img.classList.add('is-active');
        } else {
          img.style.display = 'none';
          img.classList.remove('is-active');
        }
      });

      var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('.sezane-gallery__thumb') : [];
      thumbs.forEach(function(t){
        t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(mediaId));
      });

      if(thumbsContainer){
        var activeThumb = thumbsContainer.querySelector('.sezane-gallery__thumb.is-active');
        if(activeThumb) activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    /* --- Show correct images for a variant --- */
    function showVariantMedia(variantId){
      var featuredMediaId = variantMediaMap[String(variantId)];
      if(!featuredMediaId) return;

      var mainImages = mainContainer.querySelectorAll('.sezane-gallery__main-image');
      var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('.sezane-gallery__thumb') : [];

      /* Show: the variant's featured image + all non-variant images */
      /* Hide: other variant images */
      mainImages.forEach(function(img){
        var isVariant = img.getAttribute('data-is-variant-media') === 'true';
        var id = img.getAttribute('data-media-id');
        if(!isVariant || id === String(featuredMediaId)){
          img.style.display = '';
        } else {
          img.style.display = 'none';
          img.classList.remove('is-active');
        }
      });

      thumbs.forEach(function(t){
        var isVariant = t.getAttribute('data-is-variant-media') === 'true';
        var id = t.getAttribute('data-media-id');
        if(!isVariant || id === String(featuredMediaId)){
          t.style.display = '';
        } else {
          t.style.display = 'none';
          t.classList.remove('is-active');
        }
      });

      /* Make the featured image active (show it as main) */
      showSingleImage(featuredMediaId);

      /* Scroll the thumb strip so the variant image is at the top */
      if(thumbsContainer){
        var activeThumb = thumbsContainer.querySelector('.sezane-gallery__thumb[data-media-id="' + featuredMediaId + '"]');
        if(activeThumb){
          thumbsContainer.scrollTo({ top: activeThumb.offsetTop - thumbsContainer.offsetTop, behavior: 'smooth' });
        }
      }

      updateArrows();
    }

    /* --- Click thumbnail → show that image as main --- */
    if(thumbsContainer){
      thumbsContainer.addEventListener('click', function(e){
        var thumb = e.target.closest('.sezane-gallery__thumb');
        if(!thumb) return;
        showSingleImage(thumb.getAttribute('data-media-id'));
      });
    }

    /* --- Arrow buttons --- */
    function updateArrows(){
      if(!arrowUp || !arrowDown || !thumbsContainer) return;
      arrowUp.disabled = thumbsContainer.scrollTop <= 2;
      arrowDown.disabled = thumbsContainer.scrollTop + thumbsContainer.clientHeight >= thumbsContainer.scrollHeight - 2;
    }

    if(arrowUp && arrowDown && thumbsContainer){
      arrowUp.addEventListener('click', function(){
        thumbsContainer.scrollBy({ top: -100, behavior: 'smooth' });
      });
      arrowDown.addEventListener('click', function(){
        thumbsContainer.scrollBy({ top: 100, behavior: 'smooth' });
      });
      thumbsContainer.addEventListener('scroll', updateArrows);
      var imgs = thumbsContainer.querySelectorAll('img');
      var loaded = 0;
      imgs.forEach(function(img){
        if(img.complete){ loaded++; if(loaded === imgs.length) updateArrows(); }
        else { img.addEventListener('load', function(){ loaded++; if(loaded === imgs.length) updateArrows(); }); }
      });
    }

    /* --- Listen for ANY change on radio/select inside variant-selects --- */
    var variantSelects = document.querySelector('variant-selects');
    if(variantSelects){
      variantSelects.addEventListener('change', function(){
        setTimeout(function(){
          var variantInput = document.querySelector('input[name="id"][type="hidden"], select[name="id"]');
          if(variantInput && variantInput.value){
            showVariantMedia(variantInput.value);
          }
        }, 150);
      });
    }

    /* --- Also listen for URL changes --- */
    function checkVariantFromUrl(){
      var params = new URLSearchParams(window.location.search);
      var vid = params.get('variant');
      if(vid) showVariantMedia(vid);
    }

    var origPush = history.pushState;
    history.pushState = function(){ origPush.apply(this, arguments); setTimeout(checkVariantFromUrl, 100); };
    var origReplace = history.replaceState;
    history.replaceState = function(){ origReplace.apply(this, arguments); setTimeout(checkVariantFromUrl, 100); };
    window.addEventListener('popstate', function(){ setTimeout(checkVariantFromUrl, 100); });

    /* --- Sync thumbs height to main image --- */
    function syncThumbsHeight(){
      if(!thumbsContainer) return;
      var activeSlide = mainContainer.querySelector('.sezane-gallery__main-image.is-active') || mainContainer.querySelector('.sezane-gallery__main-image:not([style*="display:none"])');
      if(!activeSlide) return;
      var img = activeSlide.querySelector('img');
      if(!img) return;
      var h = img.getBoundingClientRect().height;
      if(h < 50) return;
      var arrowH = (arrowUp ? arrowUp.getBoundingClientRect().height : 0) + (arrowDown ? arrowDown.getBoundingClientRect().height : 0) + 8;
      thumbsContainer.style.maxHeight = (h - arrowH) + 'px';
    }

    window.addEventListener('resize', syncThumbsHeight);
    var origShowSingle = showSingleImage;
    showSingleImage = function(mediaId){
      origShowSingle(mediaId);
      requestAnimationFrame(syncThumbsHeight);
    };

    /* Observe every image in the gallery for size changes */
    var ro = new ResizeObserver(syncThumbsHeight);
    mainContainer.querySelectorAll('img').forEach(function(img){ ro.observe(img); });

    /* Also observe the container itself */
    ro.observe(mainContainer);

    

    /* --- Initial state --- */
    updateArrows();

    /* If page loaded with a specific variant, show its media */
    var initialVariantInput = document.querySelector('input[name="id"][type="hidden"], select[name="id"]');
    var initialVariantId = null;
    var urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('variant')){
      initialVariantId = urlParams.get('variant');
    } else if(initialVariantInput && initialVariantInput.value){
      initialVariantId = initialVariantInput.value;
    }
    if(initialVariantId && variantMediaMap[String(initialVariantId)]){
      showVariantMedia(initialVariantId);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initSezaneGallery);
  } else {
    initSezaneGallery();
  }
})();

